import i18next from 'i18next';
import {config as i18nextConfig} from './';

i18next.init(i18nextConfig);

const translate = (key) => i18next.t(key,{ns:'dashboard'});

export default i18next;
export { translate };
